


























































































































































































import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';
import { FormRules } from '@/mixins/FormRules';

import Vue from 'vue';
const pause = (ms: any) => new Promise(resolve => setTimeout(resolve, ms));
const enum STEP {
  REQUEST_EMAIL = 1,
  LOGIN = 2,
  COMPLETE = 3
}
export default Vue.extend({
  name: 'AuthSignInWizard',
  mixins: [FormRules],
  data: () => ({
    step: STEP.REQUEST_EMAIL,
    showPassword: false,
    email: '',
    password: '',
    loginMessage: ''
  }),

  computed: {
    getUserInfo: get('auth/getUserInfo'),
    isLoggedin: get('auth/isLoggedin'),
    authLoading: get('auth/getLoading'),
    getError: get('auth/getAuthError'),
    companyName: sync('app/companyName'),
    darkCompanyImage: sync('app/darkCompanyImage'),
    getCurrentUser: get('accounts/getCurrentUser'),
    firstButton() {
      switch (this.step) {
        case 1:
          return 'Create Account';
        case 2:
          return 'Forgot Password';
        default:
          return 'Back';
      }
    },
    currentTitle() {
      switch (this.step) {
        case 1:
          return 'Sign-up';
        case 2:
          return 'Create a password';
        default:
          return 'Account created';
      }
    }
  },
  methods: {
    ...mapActions({
      requestEmail: 'auth/requestEmail',
      login: 'auth/login',
      clearError: 'error/clearError'
    }),
    back(): number {
      return this.step--;
    },
    next(): number {
      return this.step++;
    },
    SecondaryCardButton(): any {
      switch (this.step) {
        case 1:
          return this.$router.push({ name: 'sign-up' });
        case 2:
          return this.$router.push({ name: 'password-reset' });
        case 3:
          return (this.step = 1);
        default:
          return this.back();
      }
    },
    PrimaryCardButton(): any {
      switch (this.step) {
        case 1:
          return this.authEmail(this.email);
        case 2:
          return this.verifyLogin(this.email, this.password);
        default:
          return 'Account created';
      }
    },
    async verifyLogin(email: string, password: string) {
      await this.login({ email, password })
        .then(() => this.next())
        .then(() => {
          this.loadPortal();
        });
    },
    async authEmail(email: string) {
      await this.requestEmail(email).then(() => this.next());
    },
    async loadPortal() {
      await pause(1000);
      try {
        const { redirect } = this.$route.query ?? null;
        if (redirect) {
          this.$router.push({ name: `${redirect}` });
        } else {
          this.$router.push({ name: 'select' });
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    step: {
      handler(val) {
        if (val === STEP.COMPLETE) {
          if (this.isLoggedin) {
            return val;
          } else {
            this.step = STEP.LOGIN;
          }
        }
      }
    }
  },
  mounted() {}
});
